
export default {
    name: 'SiteRating',
    props: {
        rating: {
            type: Number,
            required: true,
        },
        ratingCount: {
            type: Number,
            default: 0,
        },
        ratingText: {
            type: String,
            default: 'comments.reviews',
        },
    },
    computed: {
        ratingTextFull() {
            if (!this.ratingCount) {
                return '';
            }
            return `(${this.$tc(this.ratingText, this.ratingCount, { num: this.ratingCount })})`;
        },
    },
};
